<div class="business-list-view col-md-12 padding-right-0 padding-left-0">

    <!-- Wireframe header (.section-hd + .panel-search). Old header in #legacyHeader.
         The old "All" filter had no menu items, so it isn't carried over. -->
    <div class="gs-biz-list-hd" *ngIf="useWireframeHeader; else legacyHeader">
        <div class="gs-biz-list-row">
            <div class="gs-biz-list-title">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
                Invites Sent
                <span class="gs-biz-list-count">({{visitorsList?.length > 1 ? visitorsList?.length : (TotallCount || 0)}})</span>
            </div>
        </div>
        <div class="gs-biz-list-search">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <input type="text" placeholder="Search invites…" aria-label="Search invites sent" [(ngModel)]="searchKey"
                [ngModelOptions]="{standalone: true}" (ngModelChange)="onSearchinvite($event)">
            <button *ngIf="searchKey" type="button" class="gs-biz-list-clear" aria-label="Clear search"
                (click)="searchKey = ''; onSearchinvite('')">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
        </div>
    </div>

    <ng-template #legacyHeader>
    <div class="hpanel">
        <div class="Bnav panel-body border-radius-top-left-right-6">
            <div class="Bnav-item-11">
                <h6 class="fw-bold" data-toggle="tooltip" data-placement="top"
                    title="{{values.bussinessName}}">{{values.bussinessName| truncate : 20 }}
                </h6>
                <div>
                    <p *ngIf="visitorsList?.length>1"> Invite Sent: {{visitorsList?.length}}
                    </p>
                    <p *ngIf="visitorsList?.length==1 || visitorsList?.length==0">Invite Sent: {{TotallCount}}
                    </p>

                </div>
            </div>
            <div class="Bnav-item-22">
                        <!-- <input type="text" class="form-control" placeholder="Search Followers" [(ngModel)]="empSearch"
                            [ngModelOptions]="{standalone: true}" (keyup)="keyupdata($event)" (keyup.enter)="onsearch(empSearch)" aria-label="Amount (to the nearest dollar)">
                            <span class="input-group-addon"  (click)="onsearch(empSearch)" id="my_btn" ><ng-icon name="tablerSearch"></ng-icon></span>                    -->

                            <input #requestListText type="text" class="form-control" placeholder="Search Followers" style="z-index: 1;" [(ngModel)]="searchKey"
                            [ngModelOptions]="{standalone: true}" aria-label="Amount (to the nearest dollar)" (input)="onSearchinvite(requestListText.value)">

            </div>
            <div class="Bnav-item-33" *ngIf="businessData?.isSuperAdmin === 'true' || businessData?.isAdmin === 'true'">
                <div class="btn-group " dropdown container="body">
                    <button id="button-container" class="btn btn-primary dropdown-toggle  " dropdownToggle
                        aria-controls="dropdown-container" style="border-radius: 8px !important; height: 32px !important;">
                        <div class="filter-common" style="gap: 5px !important;">
                          <span>All</span>
                          <ng-icon name="tablerFilter"></ng-icon>
                        </div>
                    </button>
                    <!-- <ul id="dropdown-container" *dropdownMenu class="dropdown-menu m-l-43 " role="menu"
                        aria-labelledby="button-container">
                        <li role="menuitem"><a class="dropdown-item" >Pending Acceptance </a></li>
                    </ul> -->
                </div>
            </div>
        </div>
    </div>
    </ng-template>
    <ng-container *ngIf="loadAPIcall && !loadScroll">
      <div class="follower-body">
        <div class="col-sm-12 kcid col-md-6 col-lg-6 padding-right-5 padding-left-0"
          *ngFor="let n of [1, 2, 3, 4, 5, 6]">
          <app-common-skeleton [NameOftheScreen]="'usercardWireframe'"></app-common-skeleton>
        </div>
      </div>
    </ng-container>
    <div class="follower-body" *ngIf="(requestList | async)?.length > 0" infiniteScroll [alwaysCallback]="true"
      [infiniteScrollDistance]="5" [infiniteScrollThrottle]="300" (scrolled)="onScrollDown()">
    <!-- | customFilter:{userName:searchKey}:false ;index as i -->
    <div class="col-sm-12 col-md-6 col-lg-6 padding-right-5 padding-left-0 padding-bottom-5"  *ngFor="let data of (requestList | async)">
      <app-user-card [userDataInput]="data" [config]="userCardConfig" [button]="'PRIMARY'" [variant]="'wireframe'" [showStats]="false"
      [adminFlag]="true" [refresh]="true" [userIdInput]="data.userId">
    </app-user-card>
  </div>
  <ng-container *ngIf="loadScroll">
    <div class="col-sm-12 col-md-6 col-lg-6 padding-right-5 padding-left-0 pd-5"
      *ngFor="let n of [1, 2]">
      <app-common-skeleton [NameOftheScreen]="'usercardWireframe'"></app-common-skeleton>
    </div>
  </ng-container>
  <div class="col-sm-12 pl-1 end" *ngIf="stopScroll && (requestList | async)?.length > 0"
    style="text-align: center;padding-top: 1rem;">
    <div class="col-sm-12">
      <ng-icon name="tablerCircleCheck"></ng-icon>
    </div>
    <div class="col-sm-12">
      <p class="fontchange">You've reached the bottom of the page</p>
    </div>
   </div>
  </div>
</div>
<div class="col-md-12 pad" *ngIf="(requestList | async)?.length === 0 && showNoDatafound">
 <app-nodata-found [title]="noDatafound"></app-nodata-found>
</div>
